import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'leaflet/dist/leaflet.css';

import cepMask from './diretives/cepMask';
import cnpjMask from './diretives/cnpjMask';
import cpfMask from './diretives/cpfMask';
import decimalMask from './diretives/decimalMask';
import decimalSignedMask from './diretives/decimalSignedMask';
import digitsOnly from './diretives/digitsOnly';
import maskCpfCnpj from './diretives/maskCpfCnpj';
import numberMask from './diretives/numberMask';
import phoneMask from './diretives/phoneMask';
import timeMask from './diretives/timeMask';
import uppercase from './diretives/uppercase';

createApp(App)
    .directive('cep', cepMask)
    .directive('cnpj', cnpjMask)
    .directive('cpf', cpfMask)
    .directive('decimal', decimalMask)
    .directive('decimal-mask', decimalMask)
    .directive('decimal-signed', decimalSignedMask)
    .directive('digits-only', digitsOnly)
    .directive('fone', phoneMask)
    .directive('mask-cpf-cnpj', maskCpfCnpj)
    .directive('number', numberMask)
    .directive('phone', phoneMask)
    .directive('time', timeMask)
    .directive('time-mask', timeMask)
    .directive('uppercase', uppercase)
    .use(router)
    .mount('#app');